import React from "react";

const UserAgreement = () => {
    const containerStyle: React.CSSProperties = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: '#fff',
        padding: '24px 0',
        boxSizing: 'border-box',
    };
    const contentStyle: React.CSSProperties = {
        width: '100%',
        maxWidth: 800,
        padding: '0 16px',
        boxSizing: 'border-box',
        color: '#333',
        fontSize: 14,
        lineHeight: 1.8,
        fontFamily: 'inherit',
    };
    const titleStyle: React.CSSProperties = {
        fontSize: 20,
        fontWeight: 700,
        textAlign: 'center',
        margin: '0 0 8px',
    };
    const updatedStyle: React.CSSProperties = {
        textAlign: 'center',
        fontSize: 13,
        color: '#666',
        margin: '0 0 24px',
    };
    const headingStyle: React.CSSProperties = {
        fontSize: 16,
        fontWeight: 700,
        margin: '24px 0 12px',
    };
    const subHeadingStyle: React.CSSProperties = {
        fontSize: 14,
        fontWeight: 700,
        margin: '16px 0 8px',
    };
    const paragraphStyle: React.CSSProperties = {
        margin: '0 0 12px',
    };
    const bulletStyle: React.CSSProperties = {
        margin: '0 0 8px',
        paddingLeft: 16,
    };
    const listStyle: React.CSSProperties = {
        margin: '0 0 12px',
        paddingLeft: 16,
    };

    return (
        <div style={containerStyle}>
            <div style={contentStyle}>
                <h1 style={titleStyle}>TERMS OF USE</h1>
                <div style={updatedStyle}>Effective Date: 1 June 2026</div>

                <h2 style={headingStyle}>TABLE OF CONTENTS</h2>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Introduction and Acceptance</li>
                    <li style={bulletStyle}>Definitions</li>
                    <li style={bulletStyle}>License Grant</li>
                    <li style={bulletStyle}>Account Registration</li>
                    <li style={bulletStyle}>Subscriptions and In-App Purchases</li>
                    <li style={bulletStyle}>User Content</li>
                    <li style={bulletStyle}>Acceptable Use</li>
                    <li style={bulletStyle}>Intellectual Property</li>
                    <li style={bulletStyle}>Third-Party Services</li>
                    <li style={bulletStyle}>Privacy and Data Collection</li>
                    <li style={bulletStyle}>Disclaimers</li>
                    <li style={bulletStyle}>Limitation of Liability</li>
                    <li style={bulletStyle}>Indemnification</li>
                    <li style={bulletStyle}>Termination</li>
                    <li style={bulletStyle}>App Store Terms</li>
                    <li style={bulletStyle}>Dispute Resolution</li>
                    <li style={bulletStyle}>General Provisions</li>
                    <li style={bulletStyle}>Contact Information</li>
                </ul>

                <h2 style={headingStyle}>1. INTRODUCTION AND ACCEPTANCE</h2>
                <h3 style={subHeadingStyle}>1.1 Agreement</h3>
                <p style={paragraphStyle}>
                    These Terms of Use (&quot;Terms&quot;) govern your download, installation, and use of the E Go Africa mobile application (the &quot;App&quot;) provided by E Go Cote D&apos;Ivoire, a &quot;Company&quot;.
                </p>
                <h3 style={subHeadingStyle}>1.2 Acceptance</h3>
                <p style={paragraphStyle}>
                    By downloading, installing, accessing, or using the App, you (&quot;User,&quot; &quot;you,&quot; or &quot;your&quot;) agree to be bound by these Terms and our Privacy Policy. If you do not agree, do not download or use the App.
                </p>
                <h3 style={subHeadingStyle}>1.3 Eligibility</h3>
                <p style={paragraphStyle}>
                    You must be at least 18 years of age to use the App. If you are under 18, you may only use the App with parental or guardian consent.
                </p>
                <h3 style={subHeadingStyle}>1.4 Changes to Terms</h3>
                <p style={paragraphStyle}>
                    We may update these Terms from time to time. We will notify you of material changes through the App or by other means. Continued use after changes constitutes acceptance.
                </p>

                <h2 style={headingStyle}>2. DEFINITIONS</h2>
                <ul style={listStyle}>
                    <li style={bulletStyle}>&quot;App&quot; means the E Go Africa mobile application for iOS and/or Android devices.</li>
                    <li style={bulletStyle}>&quot;App Store&quot; means Apple&apos;s App Store or Google Play Store through which you downloaded the App.</li>
                    <li style={bulletStyle}>&quot;App Store Provider&quot; means Apple Inc. (for iOS) or Google LLC (for Android).</li>
                    <li style={bulletStyle}>&quot;Content&quot; means all text, images, audio, video, data, and other materials in or through the App.</li>
                    <li style={bulletStyle}>&quot;Device&quot; means a compatible smartphone, tablet, or other mobile device.</li>
                    <li style={bulletStyle}>&quot;In-App Purchase&quot; means any purchase made within the App for premium features, content, or subscriptions.</li>
                    <li style={bulletStyle}>&quot;Services&quot; means all features, functionality, and services provided through the App.</li>
                    <li style={bulletStyle}>&quot;User Content&quot; means any content you create, upload, or submit through the App.</li>
                </ul>

                <h2 style={headingStyle}>3. LICENSE GRANT</h2>
                <h3 style={subHeadingStyle}>3.1 Limited License</h3>
                <p style={paragraphStyle}>
                    Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to:
                </p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Download and install the App on your personal Device(s)</li>
                    <li style={bulletStyle}>Access and use the App for your personal, non-commercial purposes</li>
                    <li style={bulletStyle}>Access content and features included in your subscription tier (if applicable)</li>
                </ul>
                <h3 style={subHeadingStyle}>3.2 License Restrictions</h3>
                <p style={paragraphStyle}>You may NOT:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Copy, modify, or distribute the App or its content</li>
                    <li style={bulletStyle}>Reverse engineer, decompile, or disassemble the App</li>
                    <li style={bulletStyle}>Remove or alter any proprietary notices or labels</li>
                    <li style={bulletStyle}>Use the App for any commercial purpose without authorization</li>
                    <li style={bulletStyle}>Rent, lease, loan, or sublicense the App</li>
                    <li style={bulletStyle}>Use the App on more devices than permitted by your license</li>
                    <li style={bulletStyle}>Attempt to bypass any security or access controls</li>
                    <li style={bulletStyle}>Use automated systems (bots, scrapers) to access the App</li>
                    <li style={bulletStyle}>Extract data or content from the App</li>
                </ul>
                <h3 style={subHeadingStyle}>3.3 Device Limitations</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>The App may be installed on up to 5 Devices linked to your account</li>
                    <li style={bulletStyle}>You may transfer the App to a new Device by deauthorizing the old one</li>
                    <li style={bulletStyle}>Family sharing may be available per App Store policies</li>
                </ul>
                <h3 style={subHeadingStyle}>3.4 Updates</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>We may release updates, patches, and new versions of the App</li>
                    <li style={bulletStyle}>Updates may be required for continued use</li>
                    <li style={bulletStyle}>Some updates may be installed automatically</li>
                    <li style={bulletStyle}>Failure to update may result in reduced functionality</li>
                </ul>

                <h2 style={headingStyle}>4. ACCOUNT REGISTRATION</h2>
                <h3 style={subHeadingStyle}>4.1 Account Creation</h3>
                <p style={paragraphStyle}>To access certain features, you may need to create an account:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Provide accurate and complete registration information</li>
                    <li style={bulletStyle}>Choose a secure password</li>
                    <li style={bulletStyle}>Keep your login credentials confidential</li>
                    <li style={bulletStyle}>Notify us immediately of unauthorized account use</li>
                </ul>
                <h3 style={subHeadingStyle}>4.2 Account Security</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>You are responsible for all activity under your account</li>
                    <li style={bulletStyle}>Enable biometric authentication or PIN if available</li>
                    <li style={bulletStyle}>Do not share your account with others</li>
                    <li style={bulletStyle}>Log out when using shared or public devices</li>
                </ul>
                <h3 style={subHeadingStyle}>4.3 Account Termination</h3>
                <p style={paragraphStyle}>We may suspend or terminate your account if:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>You violate these Terms</li>
                    <li style={bulletStyle}>You provide false registration information</li>
                    <li style={bulletStyle}>You engage in fraudulent activity</li>
                    <li style={bulletStyle}>Your account shows extended inactivity</li>
                </ul>

                <h2 style={headingStyle}>5. SUBSCRIPTIONS AND IN-APP PURCHASES</h2>
                <h3 style={subHeadingStyle}>5.1 In-App Purchases</h3>
                <p style={paragraphStyle}>The App may offer In-App Purchases including:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Premium features or content</li>
                    <li style={bulletStyle}>Subscription access</li>
                    <li style={bulletStyle}>Virtual items or currency</li>
                    <li style={bulletStyle}>One-time purchases</li>
                </ul>
                <h3 style={subHeadingStyle}>5.2 Pricing</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Prices are displayed in the App and App Store</li>
                    <li style={bulletStyle}>Prices are in your local currency as determined by the App Store</li>
                    <li style={bulletStyle}>Prices may vary by region</li>
                    <li style={bulletStyle}>Prices are subject to change</li>
                </ul>
                <h3 style={subHeadingStyle}>5.3 Payment Processing</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>All payments are processed by the App Store Provider</li>
                    <li style={bulletStyle}>You must have a valid payment method on file with the App Store</li>
                    <li style={bulletStyle}>Payment terms are subject to App Store policies</li>
                    <li style={bulletStyle}>We do not have access to your payment card information</li>
                </ul>

                <h2 style={headingStyle}>7. ACCEPTABLE USE</h2>
                <h3 style={subHeadingStyle}>7.1 Permitted Uses</h3>
                <p style={paragraphStyle}>You may use the App to:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Access features included in your subscription</li>
                    <li style={bulletStyle}>Create and share User Content as intended</li>
                    <li style={bulletStyle}>Engage with other users as the App allows</li>
                </ul>
                <h3 style={subHeadingStyle}>7.2 Prohibited Uses</h3>
                <p style={paragraphStyle}>You may NOT:</p>
                <p style={paragraphStyle}><strong>Illegal Activities:</strong></p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Violate any applicable law or regulation</li>
                    <li style={bulletStyle}>Engage in fraud or illegal transactions</li>
                    <li style={bulletStyle}>Facilitate any criminal activity</li>
                </ul>
                <p style={paragraphStyle}><strong>Harmful Behavior:</strong></p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Harass, bully, or threaten other users</li>
                    <li style={bulletStyle}>Stalk or collect personal information about others</li>
                    <li style={bulletStyle}>Post hate speech or discriminatory content</li>
                    <li style={bulletStyle}>Distribute sexually explicit content (unless the App is age-gated)</li>
                </ul>
                <p style={paragraphStyle}><strong>Technical Abuse:</strong></p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Attempt to access others&apos; accounts</li>
                    <li style={bulletStyle}>Interfere with App functionality or security</li>
                    <li style={bulletStyle}>Use automated scripts or bots</li>
                    <li style={bulletStyle}>Circumvent usage limits or geo-restrictions</li>
                </ul>
                <p style={paragraphStyle}><strong>Commercial Misuse:</strong></p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Use the App for unauthorized commercial purposes</li>
                    <li style={bulletStyle}>Resell or redistribute App features</li>
                    <li style={bulletStyle}>Advertise or solicit without permission</li>
                </ul>

                <h2 style={headingStyle}>8. INTELLECTUAL PROPERTY</h2>
                <h3 style={subHeadingStyle}>8.1 App Ownership</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>The App and all Content are owned by Company or its licensors</li>
                    <li style={bulletStyle}>All rights not expressly granted are reserved</li>
                    <li style={bulletStyle}>The App is protected by copyright, trademark, and other laws</li>
                </ul>

                <h2 style={headingStyle}>9. THIRD-PARTY SERVICES</h2>
                <h3 style={subHeadingStyle}>9.1 Third-Party Integrations</h3>
                <p style={paragraphStyle}>The App may integrate with or link to third-party services:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Social media platforms</li>
                    <li style={bulletStyle}>Payment processors</li>
                    <li style={bulletStyle}>Analytics providers</li>
                    <li style={bulletStyle}>Advertising networks</li>
                    <li style={bulletStyle}>Other third-party APIs</li>
                </ul>
                <h3 style={subHeadingStyle}>9.2 Third-Party Terms</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Your use of third-party services is subject to their terms</li>
                    <li style={bulletStyle}>We are not responsible for third-party services</li>
                    <li style={bulletStyle}>We do not endorse third-party services</li>
                </ul>
                <h3 style={subHeadingStyle}>9.3 Third-Party Content</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Third-party content may appear in the App</li>
                    <li style={bulletStyle}>We do not control or endorse third-party content</li>
                    <li style={bulletStyle}>Access third-party content at your own risk</li>
                </ul>

                <h2 style={headingStyle}>10. PRIVACY AND DATA COLLECTION</h2>
                <h3 style={subHeadingStyle}>10.1 Privacy Policy</h3>
                <p style={paragraphStyle}>
                    Our collection and use of your personal information is governed by our Privacy Policy which is incorporated into these Terms.
                </p>
                <h3 style={subHeadingStyle}>10.2 Data Collection</h3>
                <p style={paragraphStyle}>The App may collect:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Account and profile information</li>
                    <li style={bulletStyle}>Device information and identifiers</li>
                    <li style={bulletStyle}>Usage data and analytics</li>
                    <li style={bulletStyle}>Location data (with permission)</li>
                    <li style={bulletStyle}>Photos, camera, or microphone (with permission)</li>
                    <li style={bulletStyle}>Contacts (with permission)</li>
                    <li style={bulletStyle}>Health data (with permission, if applicable)</li>
                </ul>
                <h3 style={subHeadingStyle}>10.3 Permissions</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>The App will request permissions for device features</li>
                    <li style={bulletStyle}>You may grant or deny permissions</li>
                    <li style={bulletStyle}>Some features may require specific permissions to function</li>
                    <li style={bulletStyle}>You can manage permissions in your device settings</li>
                </ul>

                <h2 style={headingStyle}>11. DISCLAIMERS</h2>
                <h3 style={subHeadingStyle}>11.1 &quot;As Is&quot; Disclaimer</h3>
                <p style={paragraphStyle}>
                    THE APP IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.
                </p>
                <h3 style={subHeadingStyle}>11.2 Specific Disclaimers</h3>
                <p style={paragraphStyle}>WE DISCLAIM ALL WARRANTIES, INCLUDING:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE</li>
                    <li style={bulletStyle}>NON-INFRINGEMENT</li>
                    <li style={bulletStyle}>THAT THE APP WILL BE UNINTERRUPTED OR ERROR-FREE</li>
                    <li style={bulletStyle}>THAT DEFECTS WILL BE CORRECTED</li>
                    <li style={bulletStyle}>THAT THE APP IS FREE OF VIRUSES OR HARMFUL COMPONENTS</li>
                    <li style={bulletStyle}>ACCURACY OR RELIABILITY OF ANY CONTENT</li>
                </ul>
                <h3 style={subHeadingStyle}>11.3 Third-Party Disclaimer</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>We are not responsible for third-party services or content</li>
                    <li style={bulletStyle}>We do not guarantee third-party service availability</li>
                </ul>
                <h3 style={subHeadingStyle}>11.4 Device Compatibility</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>We do not guarantee compatibility with all devices or OS versions</li>
                    <li style={bulletStyle}>You are responsible for ensuring your device meets requirements</li>
                </ul>

                <h2 style={headingStyle}>12. LIMITATION OF LIABILITY</h2>
                <h3 style={subHeadingStyle}>12.1 Exclusion of Damages</h3>
                <p style={paragraphStyle}>TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Indirect, incidental, special, or consequential damages</li>
                    <li style={bulletStyle}>Lost profits, data, or business opportunities</li>
                    <li style={bulletStyle}>Personal injury (except where caused by our negligence)</li>
                    <li style={bulletStyle}>Device damage or data loss</li>
                    <li style={bulletStyle}>Third-party claims</li>
                </ul>
                <h3 style={subHeadingStyle}>12.2 Maximum Liability</h3>
                <p style={paragraphStyle}>OUR TOTAL LIABILITY SHALL NOT EXCEED THE GREATER OF:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>$100</li>
                </ul>
                <h3 style={subHeadingStyle}>12.3 App Store Provider Disclaimer</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>App Store Providers have no obligation to provide support</li>
                    <li style={bulletStyle}>App Store Providers have no liability for the App</li>
                    <li style={bulletStyle}>See Section 15 for additional App Store terms</li>
                </ul>

                <h2 style={headingStyle}>13. INDEMNIFICATION</h2>
                <p style={paragraphStyle}>
                    You agree to indemnify and hold harmless Company and its affiliates from any claims, damages, liabilities, and expenses arising from:
                </p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Your use of the App</li>
                    <li style={bulletStyle}>Your User Content</li>
                    <li style={bulletStyle}>Your violation of these Terms</li>
                    <li style={bulletStyle}>Your violation of any third-party rights</li>
                    <li style={bulletStyle}>Your violation of any law</li>
                </ul>

                <h2 style={headingStyle}>14. TERMINATION</h2>
                <h3 style={subHeadingStyle}>14.1 Termination by You</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>You may stop using the App at any time</li>
                    <li style={bulletStyle}>You may delete the App from your Device</li>
                    <li style={bulletStyle}>You may cancel your subscription per App Store procedures</li>
                </ul>
                <h3 style={subHeadingStyle}>14.2 Termination by Us</h3>
                <p style={paragraphStyle}>We may terminate or suspend your access:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>For violation of these Terms</li>
                    <li style={bulletStyle}>For suspected fraudulent or illegal activity</li>
                    <li style={bulletStyle}>If required by law or App Store policies</li>
                    <li style={bulletStyle}>For any reason with reasonable notice</li>
                </ul>

                <h2 style={headingStyle}>15. APP STORE TERMS</h2>
                <h3 style={subHeadingStyle}>15.1 Acknowledgments</h3>
                <p style={paragraphStyle}>You acknowledge that:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>These Terms are between you and Company, not the App Store Provider</li>
                    <li style={bulletStyle}>Company, not the App Store Provider, is responsible for the App</li>
                    <li style={bulletStyle}>The App Store Provider has no obligation to provide maintenance or support</li>
                </ul>
                <h3 style={subHeadingStyle}>15.2 Apple App Store Terms (iOS Users)</h3>
                <p style={paragraphStyle}>If you downloaded the App from Apple&apos;s App Store:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Apple is not responsible for the App or its content</li>
                    <li style={bulletStyle}>Apple has no obligation to provide support or maintenance</li>
                    <li style={bulletStyle}>In case of any failure to conform to any warranty, you may notify Apple for a refund of the purchase price (if any); Apple has no other warranty obligation</li>
                    <li style={bulletStyle}>Apple is not responsible for addressing any claims relating to the App</li>
                    <li style={bulletStyle}>Apple is not responsible for any third-party claims that the App infringes intellectual property rights</li>
                    <li style={bulletStyle}>Apple and its subsidiaries are third-party beneficiaries of these Terms and may enforce them against you</li>
                </ul>
                <h3 style={subHeadingStyle}>15.3 Google Play Store Terms (Android Users)</h3>
                <p style={paragraphStyle}>If you downloaded the App from Google Play Store:</p>
                <ul style={listStyle}>
                    <li style={bulletStyle}>Google is not responsible for the App or its content</li>
                    <li style={bulletStyle}>Google has no obligation to provide support or maintenance</li>
                    <li style={bulletStyle}>Refunds are handled according to Google Play&apos;s refund policies</li>
                    <li style={bulletStyle}>Google is not responsible for addressing any claims relating to the App</li>
                </ul>
                <h3 style={subHeadingStyle}>15.4 App Store Guidelines</h3>
                <ul style={listStyle}>
                    <li style={bulletStyle}>The App complies with applicable App Store guidelines</li>
                    <li style={bulletStyle}>You agree to comply with App Store terms when using the App</li>
                </ul>

                <h2 style={headingStyle}>16. DISPUTE RESOLUTION</h2>
                <h3 style={subHeadingStyle}>16.1 Governing Law</h3>
                <p style={paragraphStyle}>
                    These Terms are governed by the laws of the State of Cote D&apos;Ivoire, without regard to conflict of law principles.
                </p>
                <h3 style={subHeadingStyle}>16.2 Informal Resolution</h3>
                <p style={paragraphStyle}>
                    Before initiating formal proceedings, you agree to contact us at infosci@egoafrique.com to attempt to resolve the dispute informally for 30 days.
                </p>
                <h3 style={subHeadingStyle}>16.3 Arbitration/Litigation</h3>
                <p style={paragraphStyle}>OPTION A: Binding Arbitration</p>
                <p style={paragraphStyle}>
                    Disputes shall be resolved by binding arbitration under AAA/JAMS rules in Cote D&apos;Ivoire.
                </p>
                <p style={paragraphStyle}>OPTION B: Litigation</p>
                <p style={paragraphStyle}>
                    Disputes shall be resolved in courts located in Cote D&apos;Ivoire.
                </p>
                <h3 style={subHeadingStyle}>16.4 Class Action Waiver</h3>
                <p style={paragraphStyle}>
                    TO THE EXTENT PERMITTED BY LAW, ALL CLAIMS MUST BE BROUGHT INDIVIDUALLY, NOT AS A CLASS ACTION.
                </p>
                <h3 style={subHeadingStyle}>16.5 Jury Waiver</h3>
                <p style={paragraphStyle}>
                    EACH PARTY WAIVES THE RIGHT TO A JURY TRIAL.
                </p>

                <h2 style={headingStyle}>17. GENERAL PROVISIONS</h2>
                <h3 style={subHeadingStyle}>17.1 Entire Agreement</h3>
                <p style={paragraphStyle}>
                    These Terms constitute the entire agreement regarding your use of the App.
                </p>
                <h3 style={subHeadingStyle}>17.2 Severability</h3>
                <p style={paragraphStyle}>
                    If any provision is unenforceable, remaining provisions continue in effect.
                </p>
                <h3 style={subHeadingStyle}>17.3 Waiver</h3>
                <p style={paragraphStyle}>
                    Failure to enforce any provision does not constitute a waiver.
                </p>
                <h3 style={subHeadingStyle}>17.4 Assignment</h3>
                <p style={paragraphStyle}>
                    You may not assign. We may assign without restriction.
                </p>
                <h3 style={subHeadingStyle}>17.5 Force Majeure</h3>
                <p style={paragraphStyle}>
                    We are not liable for delays due to circumstances beyond our control.
                </p>
                <h3 style={subHeadingStyle}>17.6 Contact for Legal Notices</h3>
                <p style={paragraphStyle}>
                    Legal notices to us should be sent to infosci@egoafrique.com
                </p>
            </div>
        </div>
    )
}
export default UserAgreement
